import { StorageProvider } from "./storage-provider.interface";

export class LocalStorageProvider implements StorageProvider {
  private prefix = "quotiss";

  public get(key: string): any {
    const storedString = localStorage.getItem(this.getPrefixedKey(key));
    let storedItem: any = null;

    try {
      storedItem = JSON.parse(storedString);
    } catch {
      // continue regardless of error
    }

    return storedItem;
  }

  public set(key: string, value: any): void {
    localStorage.setItem(this.getPrefixedKey(key), JSON.stringify(value));
  }

  public remove(key: string): void {
    localStorage.removeItem(this.getPrefixedKey(key));
  }

  public getPrefixedKey(key: string): string {
    return this.prefix + "." + key;
  }
}
